import SortUtils from "../SortUtils";

export default class CompanyUtils extends SortUtils {
  
  constructor() {
    super();
  }
  
  static SortBy_name = function(a,b) {
    return CompanyUtils.SortBy_nameAz(a, b);
  }

  static SortBy_nameAz = function(a,b) {
    return SortUtils.SortBy("name", a, b);
  }

  static SortBy_nameZa = function(a,b) {
    return SortUtils.SortByDesc("name", a, b);
  }

  static SortBy_createdDateAz = function(a,b) {
    return SortUtils.SortBy("createdDate", a, b);
  }

  static SortBy_createdDateZa = function(a,b) {
    return SortUtils.SortByDesc("createdDate",a, b);
  }

  static SortBy_contractStartAz = function(a,b) {
    return SortUtils.SortBy("contractStart", a, b);
  }

  static SortBy_contractStartZa = function(a,b) {
    return SortUtils.SortByDesc("contractStart", a, b);
  }

}